// @ts-nocheck
import React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

export default function DestinatariosReduced(props) {
    const maximo = 3;
    const destinatarios = props.destinatarios.slice(0, maximo);

    return (
        <Box
            display="flex"
            flexWrap="wrap"
            gap={0.5}
            sx={{ maxWidth: '100%', overflow: 'hidden', width: { xs: '170px', sm: "auto" } }}
        >
            {destinatarios.map((destinatario, index) => (
                <Chip
                    key={index}
                    color="primary"
                    size="small"
                    label={destinatario}
                    sx={{ maxWidth: '100%' }}
                />
            ))}
            {props.destinatarios.length > maximo && (
                <Chip
                    color="primary"
                    size="small"
                    label={`+${props.destinatarios.length - maximo}`}
                />
            )}
        </Box>
    );
}
